module.exports = __webpack_public_path__ + "static/media/proj17_img1.a10e4ee4.jpg";